export default "__VITE_ASSET__D1_GR7U0__"